import { AuthenticationError, InvalidMfaCodeError, PasswordError } from '@extrahorizon/javascript-sdk';
import { randomId } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import { PortalError } from 'services/errors/PortalError';

export const displayNotificationSuccess = (options: {
  message: ReactNode;
  title?: string;
  notificationId?: string;
  autoClose?: number;
}) => {
  const notificationTitle = options?.title || t('success_label');

  const notification = {
    title: notificationTitle,
    message: options.message,
    color: 'var(--mantine-color-turquoise-5)',
    icon: <BsCheck size={24} />,
    autoClose: options.autoClose,
    loading: false,
  };

  if (options.notificationId) {
    notifications.update({ ...notification, id: options.notificationId });
    return;
  }

  notifications.show(notification);
};

export const translateError = (error?: Error) => {
  if (error instanceof AuthenticationError) return t('api_authentication_error');
  if (error instanceof InvalidMfaCodeError) return t('api_invalid_mfa_code_error');
  if (error instanceof PasswordError) return t('api_password_error');
  if (error instanceof PortalError && error?.key) return t(error.key);

  return t('api_error_refr');
};

export const displayNotificationError = (options?: { error?: Error; title?: string; notificationId?: string }) => {
  const notification = {
    title: options?.title || t('error_label'),
    message: translateError(options?.error),
    color: 'var(--mantine-color-red-5)',
    icon: <BsExclamation size={24} />,
    loading: false,
  };

  if (options?.notificationId) {
    notifications.update({ ...notification, id: options.notificationId });
    return;
  }

  notifications.show(notification);
};

export const displayNotificationLoading = (options: { title?: string; message: string }) => {
  const notificationId = randomId();

  const notification = {
    id: notificationId,
    title: options.title,
    message: options.message,
    loading: true,
    autoClose: false,
  };

  notifications.show(notification);

  return notificationId;
};
